export const ContractIcon = ({ color = '#D49006' }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 23.833c-.903 0-1.67-.316-2.302-.948-.632-.632-.948-1.4-.948-2.303v-3.25H6.5V2.167H22.75v18.417c0 .903-.316 1.67-.948 2.302-.632.633-1.4.949-2.302.949H6.5ZM19.5 21.667c.307 0 .564-.104.772-.312.208-.208.312-.466.312-.771V4.333H8.667V17.333H18.417v3.25c0 .305.104.563.311.771.208.208.465.313.772.313ZM9.75 9.75V7.583H19.5V9.75H9.75ZM9.75 13V10.833H19.5V13H9.75ZM6.5 21.667H16.25V19.5H5.417v1.083c0 .305.104.563.311.771.208.208.465.313.772.313Z"
      fill={color}
    />
  </svg>
);
